const RUNTIME_STATES = Object.freeze({
    IDLE: 'IDLE',
    RUNNING: 'RUNNING',
    PAUSED: 'PAUSED',
    FINISHED: 'FINISHED',
});

const RUNTIME_ACTIONS = Object.freeze({
    START: 'START',
    PAUSE: 'PAUSE',
    RESUME: 'RESUME',
    FINISH: 'FINISH',
    RESET: 'RESET',
});

const TRANSITION_TABLE = Object.freeze({
    [RUNTIME_STATES.IDLE]: {
        [RUNTIME_ACTIONS.START]: RUNTIME_STATES.RUNNING,
    },
    [RUNTIME_STATES.RUNNING]: {
        [RUNTIME_ACTIONS.PAUSE]: RUNTIME_STATES.PAUSED,
        [RUNTIME_ACTIONS.FINISH]: RUNTIME_STATES.FINISHED,
    },
    [RUNTIME_STATES.PAUSED]: {
        [RUNTIME_ACTIONS.RESUME]: RUNTIME_STATES.RUNNING,
        [RUNTIME_ACTIONS.FINISH]: RUNTIME_STATES.FINISHED,
    },
    [RUNTIME_STATES.FINISHED]: {
        [RUNTIME_ACTIONS.RESET]: RUNTIME_STATES.IDLE,
    },
});

export {
    RUNTIME_ACTIONS,
    RUNTIME_STATES,
    TRANSITION_TABLE,
};
